export default {"src":"/_next/static/media/maid.5f8604ba.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};